import React from "react";
import styles from "./LessonLoader.module.css";
import Spinner from "../Spinner/Spinner";

const LessonLoader = () => {
    return (
        <div className={styles.container}>
            <Spinner label={"Loading..."}/>
            <div style={{marginTop: 10, fontFamily: "Nunito, sans-serif"}}>Loading lesson...</div>
        </div>
    );
}

export default LessonLoader;